import { render, staticRenderFns } from "./ser_contribute.vue?vue&type=template&id=47d64d42&scoped=true&"
import script from "./ser_contribute.vue?vue&type=script&lang=js&"
export * from "./ser_contribute.vue?vue&type=script&lang=js&"
import style0 from "./ser_contribute.vue?vue&type=style&index=0&id=47d64d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d64d42",
  null
  
)

export default component.exports